import { pushToArray } from './common/helpers';

export type LibraryDeliveryTag =
  | 'beacon'
  | 'beacon:failure'
  | 'beacon:error'
  | 'beacon:noop'
  | 'fetch'
  | 'fetch:failure'
  | 'safeguard'
  | 'beforeunload'
  | 'visibilitychange'
  | 'pool:scheduled'
  | `chunk:${number}`
  | `size:${number}`;

export const stampEventDeliveryTags = <
  T extends { library_delivery?: LibraryDeliveryTag[] },
>(
  events: T[],
  tags: LibraryDeliveryTag[]
): void => {
  events.forEach((event) => pushToArray(event.library_delivery, tags));
};
